import React, { useEffect, useState } from 'react';
import { Button, InputAdornment, TextField } from '@mui/material';
import NanodropField from 'components/NanodropField';
import axios from 'axios';
import SaveIcon from '@mui/icons-material/Save';
import PrintIcon from '@mui/icons-material/Print';
import { getPrintLabel } from 'pages/samples/DNA';

export default function NanodropStep({samples, ...props}) {
  const [concentrations, setConcentrations] = useState({})
  const [volume, setVolume] = useState(50)
  const handleShowMessage = x => setMessage(x)
  const [message, setMessage] = useState("")
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => setMessage(""), 5000);
      return () => clearTimeout(timer);
    }
  }, [message]);
  const handleSubmit = (event) => {
    event.preventDefault()
    const committed_data = Object.entries(concentrations).map(([key, val]) => ({id: key, concentration: 1000 * val, volume: 1000 * volume}))
    axios.post('/api/wetlab/dna/update', committed_data)
      .then(({status}) => status === 200 && handleShowMessage("Concentrations saved"))
      .catch(() => handleShowMessage("Error saving concentrations"))
  }
  const handlePrintLabels = () => {
    const dataToPrint = samples.map(x => ({
      ...x,
      // concentration from form overrides stored concentration
      ...(concentrations[x.id] ? {concentration: 1000 * parseFloat(concentrations[x.id])} : {}),
      // if no stored date, use current date
      ...(x.date ? {} : {date: new Date()}),
    }))
    const stringToPrint = dataToPrint.map(x => getPrintLabel(x).join("\t")).join("\n")
    if (navigator.clipboard) {
      navigator.clipboard.writeText(stringToPrint)
      handleShowMessage(`${samples.length > 1 ? "Labels" : "Label"} copied to clipboard`)
    }
    else
    handleShowMessage("Can't access clipboard")
  }
  return (
    <>
      <TextField
        margin="dense"
        label="Elution Volume"
        fullWidth
        variant="standard"
        slotProps={{
          htmlInput: {inputMode: "decimal"},
          input: {endAdornment: <InputAdornment position="end">μL</InputAdornment>},
        }}
        sx={{input: {textAlign: "right"}}}            
        value={volume || ""}
        onChange={e => setVolume(e.target.value)}
      />
      <NanodropField
        samples={samples}
        concentrations={concentrations}
        onChangeConcentrations={setConcentrations}
        showMessage={handleShowMessage}
      />
      <Button onClick={handleSubmit} startIcon={<SaveIcon />} color="inherit">Save</Button>
      <Button onClick={handlePrintLabels} startIcon={<PrintIcon />} color="inherit">Labels</Button>
      {message}
    </>
  )
}
